<template>
<div class="pagina-login">
    <v-snackbar v-model="snackbar" timeout="3000" top color="success">
        <span>
            Login com sucesso!
            <v-btn text @click="snackbar = !snackbar" class="white--text">Fechar</v-btn>
        </span>
    </v-snackbar>

    <v-container class="py-10 flex-grow-1">
        <v-row justify="center" no-gutters>
            <v-col cols="12" sm="11" md="10" lg="8" xl="6">
                <v-card class="cartao-login" elevation="10">
                    <v-row no-gutters>
                        <!-- Painel da marca: some no celular para o formulário ganhar a tela -->
                        <v-col cols="12" md="5" class="painel-marca d-none d-md-flex">
                            <div class="painel-marca__conteudo">
                                <!-- O logo tem fundo branco opaco; o medalhão
                                     transforma isso em elemento de design. -->
                                <div class="painel-marca__medalhao">
                                    <img
                                        src="/imgs/logo.PNG"
                                        alt="Barbearia Lisboa"
                                        class="painel-marca__logo"
                                    />
                                </div>
                                <div class="painel-marca__titulo">Área restrita</div>
                                <p class="painel-marca__texto">
                                    Agenda, equipe, serviços e a gestão financeira da barbearia
                                    em um só lugar.
                                </p>

                                <div class="painel-marca__lista">
                                    <div v-for="item in destaques" :key="item" class="painel-marca__item">
                                        <v-icon small color="white" class="mr-2">mdi-check-circle-outline</v-icon>
                                        <span>{{ item }}</span>
                                    </div>
                                </div>
                            </div>
                        </v-col>

                        <!-- Formulário -->
                        <v-col cols="12" md="7">
                            <div class="painel-formulario">
                                <div class="d-md-none text-center mb-6">
                                    <img
                                        src="/imgs/logo.PNG"
                                        alt="Barbearia Lisboa"
                                        class="logo-mobile"
                                    />
                                </div>

                                <h1 class="titulo-form">Entrar</h1>
                                <p class="subtitulo-form">
                                    Use o e-mail e a senha cadastrados para acessar o painel.
                                </p>

                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <v-text-field
                                        v-model="email"
                                        :rules="emailRules"
                                        label="E-mail"
                                        placeholder="voce@email.com"
                                        prepend-inner-icon="mdi-email-outline"
                                        type="email"
                                        outlined
                                        dense
                                        required
                                        autocomplete="email"
                                        color="indigo darken-2"
                                        @keyup.enter="entrarPeloTeclado"
                                    ></v-text-field>

                                    <v-text-field
                                        v-model="senha"
                                        :rules="passRules"
                                        :type="mostrarSenha ? 'text' : 'password'"
                                        :append-icon="mostrarSenha ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                        label="Senha"
                                        prepend-inner-icon="mdi-lock-outline"
                                        outlined
                                        dense
                                        required
                                        autocomplete="current-password"
                                        color="indigo darken-2"
                                        @click:append="mostrarSenha = !mostrarSenha"
                                        @keyup.enter="entrarPeloTeclado"
                                    ></v-text-field>

                                    <v-alert
                                        v-if="getLoginError != null"
                                        dense
                                        text
                                        type="error"
                                        class="body-2 mb-4"
                                    >
                                        {{ getLoginError }}
                                    </v-alert>

                                    <v-btn
                                        v-if="!register"
                                        block
                                        large
                                        class="botao-entrar"
                                        :disabled="!valid"
                                        :loading="getLoadingState"
                                        @click="loginAction"
                                    >
                                        <v-icon left>mdi-login-variant</v-icon>
                                        Entrar
                                    </v-btn>

                                    <div class="acoes-secundarias">
                                        <v-btn
                                            text
                                            small
                                            class="indigo--text text--darken-2"
                                            @click="recuperarSenhaAction"
                                        >
                                            Recuperar senha
                                        </v-btn>

                                        <v-btn
                                            text
                                            small
                                            class="grey--text text--darken-1"
                                            @click="reset"
                                        >
                                            Limpar
                                        </v-btn>
                                    </div>
                                </v-form>

                                <div class="aviso-acesso">
                                    <v-icon x-small class="mr-1">mdi-shield-lock-outline</v-icon>
                                    Acesso permitido apenas a usuários cadastrados pela barbearia.
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>

<script>
//import auth from "../../firebaseConfig";
//import firebase from 'firebase';
import { mapActions,mapGetters } from 'vuex'

    export default {
    data: () => ({
        register: false,
        loading: false,
        snackbar: false,
      valid: true,
      mostrarSenha: false,
      destaques: [
        'Agenda do dia e dos próximos dias',
        'Serviços, equipe e comissões',
        'Receitas, despesas e resultado do mês'
      ],

      passRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 3) || 'Senha precisa ser pelo menos 3 caracteres',

      ],
      email: '',
      senha: '',
      //passwordRepeat: '',
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail precisa ser válido',
      ],

    }),

    methods: {
    ...mapActions(['login','recuperarSenha']),

      loginAction () {

        this.loading = this.getLoadingState;
        this.$refs.form.validate();


        this.login({email: this.email, senha: this.senha});

      },
      // Enter só envia quando o botão também estaria habilitado.
      entrarPeloTeclado () {
        if(this.valid && !this.getLoadingState){
          this.loginAction()
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      recuperarSenhaAction(){


        if(typeof this.email == 'undefined' || this.email === "" || this.email == null){
          alert("Favor preencher campo email")
        }else{
          console.log(this.email);
          this.recuperarSenha(this.email)
        }
      }
    },
    computed: {
      ...mapGetters(["getCurrentUser", "getLoadingState","getLoginError", "isUserAuth"])
    }

    }
</script>

<style scoped>
.pagina-login {
    background:
        radial-gradient(circle at 15% 20%, rgba(92, 107, 192, 0.16), transparent 45%),
        radial-gradient(circle at 85% 80%, rgba(38, 166, 154, 0.14), transparent 45%),
        #f4f5f9;
    /* Cobre a área entre navbar e rodapé sem forçar rolagem extra */
    min-height: calc(100vh - 220px);
    display: flex;
    align-items: center;
}

.cartao-login {
    border-radius: 22px;
    overflow: hidden;
}

/* ---------- painel da marca ---------- */

.painel-marca {
    background: linear-gradient(150deg, #283593 0%, #3949ab 55%, #5c6bc0 100%);
    position: relative;
    align-items: center;
    justify-content: center;
}

/* Brilho suave para o painel não ficar chapado */
.painel-marca::after {
    content: '';
    position: absolute;
    top: -70px;
    right: -70px;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
}

.painel-marca__conteudo {
    position: relative;
    z-index: 1;
    padding: 40px 32px;
    color: #ffffff;
}

.painel-marca__medalhao {
    width: 132px;
    height: 132px;
    border-radius: 50%;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.22);
    overflow: hidden;
}

.painel-marca__logo {
    width: 118px;
    max-width: 100%;
    display: block;
}

.painel-marca__titulo {
    font-size: 22px;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 8px;
}

.painel-marca__texto {
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.82);
    margin-bottom: 22px;
}

.painel-marca__item {
    display: flex;
    align-items: center;
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.9);
}

.painel-marca__item + .painel-marca__item {
    margin-top: 10px;
}

/* ---------- formulário ---------- */

.painel-formulario {
    padding: 44px 40px;
}

.logo-mobile {
    width: 104px;
    max-width: 60%;
}

.titulo-form {
    font-size: 30px;
    font-weight: 800;
    color: #1c2740;
    line-height: 1.15;
    margin-bottom: 4px;
}

.subtitulo-form {
    font-size: 13.5px;
    color: #6a7a90;
    margin-bottom: 26px;
}

.botao-entrar {
    background: linear-gradient(135deg, #3949ab 0%, #5c6bc0 100%) !important;
    color: #ffffff !important;
    border-radius: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    box-shadow: 0 6px 16px rgba(57, 73, 171, 0.28);
}

/* Vuetify apaga o gradiente do botão desabilitado; devolve um cinza legível */
.botao-entrar.v-btn--disabled {
    background: #e3e5ec !important;
    color: #9aa2b5 !important;
    box-shadow: none;
}

.acoes-secundarias {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 14px;
    flex-wrap: wrap;
}

.aviso-acesso {
    margin-top: 28px;
    padding-top: 16px;
    border-top: 1px solid #eceff1;
    font-size: 11.5px;
    color: #8d97a8;
    display: flex;
    align-items: center;
}

@media (max-width: 960px) {
    .painel-formulario {
        padding: 32px 24px;
    }

    .titulo-form {
        font-size: 26px;
        text-align: center;
    }

    .subtitulo-form {
        text-align: center;
    }
}
</style>
